var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "chipMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 3,
    d: "M98,133c0,0,4.3,0,7.2,0c2.8,0,3.8,2,3.8,4s-1,6-4,6H89 M109,176.2c0,0,3.5-2.7,3.5-8.7c0-4-4-10-9-10 s-15,0-15,0 M103.5,143.5V156 M136.8,133c0,0-7.3-0.5-7.1,5c0.1,2.6,1.8,5.5,6.3,5.5c5.3-0.1,14.9-0.5,14.9-0.5 M150.4,157.5 c0,0-10.1,0-15.1,0s-9.1,6-9.1,10c0,6,3.5,8.7,3.5,8.7 M135.3,143.5V156"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cardMask"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 20,
    ry: 20,
    fill: "#fff",
    width: 600,
    height: 368
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "txtBoxes"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "txtBox",
    x: 40,
    y: 37,
    width: 90,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "txtBox",
    x: 40,
    y: 300,
    width: 195,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "txtBox",
    x: 470,
    y: 290,
    width: 80,
    height: 35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "orbClip1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#orb1"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#orb2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cardMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    fill: "#271b13",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeDasharray: "6 2 4 2.5 4 3 3.5 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "coil",
    d: "M306.1,671.4C62.6,602.5-79.4,350.4-10.9,108.3s295.2-372.5,538.7-303.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "midC",
    className: "coil",
    d: "M352.7,333.4c-79.2-30.9-137.8-142.9-100.6-235.7S386.5-16.5,449.6-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "innerC",
    className: "coil",
    d: "M404.4,221c-39.6-7.4-65.7-45.6-58.3-85.2s41.6-63.7,81.2-56.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "tri1",
    fill: "#424d9b",
    points: "0,47 0,0 44,22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "tri2",
    fill: "#424d9b",
    points: "0,47 0,0 44,22"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#424d9b"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "orb1",
    cx: 123,
    cy: 410,
    r: 105
  }), /*#__PURE__*/React.createElement("circle", {
    id: "orb2",
    cx: 540,
    cy: 45,
    r: 134
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f9bb4b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wave2",
    d: "M-941,1510c89-58,147-115,211-201s142-153,210-195s144-42,208-86s69-130,70-173s5-129,38-193 c0,0,17.5-27.5,30.9-40.1C-159.6,609.4-137,593-137,593c89-58,147-115,211-201s142-153,210-195s144-42,208-86s69-130,70-173 s5-129,38-193v1765H-941z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f9503e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wave1",
    d: "M1551.5-1044.5c0,0-63,27-131,91s-122,185-186,244s-163,152.7-206,263.3s-90,162.7-128,189.7c0,0-14,10-26,16 c-16,8-24,11-24,11s-63,27-131,91s-122,185-186,244s-163,152.7-206,263.3c-9,23.2-18.2,43.9-27.5,62.3c56.5,0,1255.5-0.1,1255.5-0.1 L1551.5-1044.5z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#orbClip1)"
  }, /*#__PURE__*/React.createElement("image", {
    className: "scratches",
    width: 150,
    href: "https://assets.codepen.io/721952/scratches2.png"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#wave2",
    fill: "#3f7773"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#wave1",
    fill: "#271b13"
  })), /*#__PURE__*/React.createElement("path", {
    id: "star",
    fill: "#fff",
    d: "M397,17.6c3-3,6.1-9.1,6.1-9.1s0.8,3.8,4.5,7.6c6.1,6.1,9.1,6.1,9.1,6.1s-3,1.5-7.6,6.1 s-6.1,9.1-6.1,9.1s-2.3-5.3-6.1-9.1s-8.3-5.3-8.3-5.3S394,20.6,397,17.6z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#txtBoxes)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.4,
    d: "M42.5,146.5c2,2,2,6.3,0,8.2 M57,163.7c5.1-5.9,5.1-19.8,0-26.3 M52.1,160.7c4.4-4.5,4.9-15.2,0-20.2      M47.8,157.2c2.9-3,2.9-10,0-13.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.68d3c913e10a16c3532a4859f8228677.svg";
export { ForwardRef as ReactComponent };